import React from 'react'
import { useNavigation } from '@react-navigation/core'
import { TouchableSection } from '@components'
import { User } from '@src/utils'
import { MobileAppFeature } from '@src/types'
import { useIsDexcomSteloSensorMode } from '@src/utils/hooks'

const SensorSection = () => {
  const navigation = useNavigation()
  const isDexcomStelo = useIsDexcomSteloSensorMode()
  const hasSteloApiAccess = User.hasFeature(MobileAppFeature.DexcomSteloApiIntegration)

  const onPress = () => {
    if (!isDexcomStelo || !hasSteloApiAccess) {
      return navigation.navigate('SensorSettings')
    }

    return navigation.navigate('DexcomSensorSettings')
  }

  return <TouchableSection onPress={onPress} iconName="record" title="Sensor" showRightArrow />
}

export default SensorSection
